import moment from "moment-mini"
import type { PollProps } from "../../../../types"

export const MatchMarketHelpers = {
        getUpcomingFlash: (flash_markets?:PollProps[]) => {
            if(!flash_markets){ return undefined }
            return flash_markets.filter(fm => fm.status == 'active' && moment().isBefore(moment(fm.end_datetime))).sort((a,b) => moment(a.end_datetime).unix() - moment(b.end_datetime).unix() || parseInt(a.poll_id) - parseInt(b.poll_id))[0]
        }
}